export function formatDate(date, locale = 'en-US') {
  date = new Date(date);
  if (isNaN(date.valueOf())) {
    return '';
  }
  return `${date.toLocaleDateString(locale, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  })} ${date.toLocaleTimeString(locale, {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    timeZoneName: 'short'
  })}`;
}
export function formatDateAsMonthDay(date, locale = 'en-US') {
  date = new Date(date);
  const month = new Intl.DateTimeFormat(locale, {
    month: 'short'
  }).format(date);
  const day = new Intl.DateTimeFormat(locale, {
    day: 'numeric'
  }).format(date);
  return `${month} ${day}`;
}
export function formatDateAsMonthYear(date, locale = 'en-US') {
  date = new Date(date);
  const year = new Intl.DateTimeFormat(locale, {
    year: 'numeric'
  }).format(date);
  const month = new Intl.DateTimeFormat(locale, {
    month: 'long'
  }).format(date);
  return `${month} ${year}`;
}
export function formatDateAsMonthDayYear(date, locale = 'en-US') {
  date = new Date(date);
  const year = new Intl.DateTimeFormat(locale, {
    year: 'numeric'
  }).format(date);
  const month = new Intl.DateTimeFormat(locale, {
    month: 'short'
  }).format(date);
  const day = new Intl.DateTimeFormat(locale, {
    day: 'numeric'
  }).format(date);
  return `${month} ${day} ${year}`;
}
export function formatDateAsYearMonthNumber(date) {
  date = new Date(date);
  const year = date.getFullYear();
  let month = date.getMonth() + 1;
  month = month.length < 2 ? `0${month}` : month;
  return `${year}${month}`;
}
//# sourceMappingURL=date.js.map